import TagsViewSectionSelectCategory from "@/components/TagsView/Sections/TagsViewSectionSelect/tagsViewSectionSelectCategory.component";
import { AppContext } from "@/services/AppContext/appContext";
import { Input } from "@/shadcn/components/ui/input";
import { TagCategory } from "@/types";
import { X } from "lucide-react";
import React, { useContext, useEffect, useState } from "react";

type TagsViewSectionSelectProps = {
  viewingTagID: number | null;
  additionalTagIDs: number[];
};

const TagsViewSectionSelect: React.FC<TagsViewSectionSelectProps> = ({
  viewingTagID,
  additionalTagIDs,
}) => {
  const { userTags } = useContext(AppContext);
  const [filteredTags, setFilteredTags] = useState<TagCategory[]>(userTags);
  const [searchText, setSearchText] = useState<string>("");

  useEffect(() => {
    const filtered = userTags.map((tagCat) => {
      const filteredTags = tagCat.tags.filter((tag) =>
        tag.name.toLowerCase().includes(searchText.toLowerCase())
      );
      return { ...tagCat, tags: filteredTags };
    });
    setFilteredTags(filtered);
  }, [userTags, searchText]);

  return (
    <div className="h-full overflow-y-scroll">
      <div className="flex flex-col gap-2 p-2">
        <h1 className="text-lg font-bold text-center">Tags</h1>
        <div className="flex flex-row gap-2 items-center relative">
          <Input
            type="text"
            placeholder="Search Tags..."
            className="border rounded p-1 w-full mb-1"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          {searchText && (
            <div className="absolute right-2 top-[10px]">
              <X
                className="w-4 h-4 cursor-pointer"
                onClick={() => setSearchText("")}
              />
            </div>
          )}
        </div>
        {filteredTags.map((tagCat, index) => (
          <div className="flex flex-col gap-3" key={`${tagCat.id}_${index}`}>
            <TagsViewSectionSelectCategory
              key={tagCat.id}
              tagCat={tagCat}
              viewingTagID={viewingTagID}
              additionalTagIDs={additionalTagIDs}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TagsViewSectionSelect;
